module.exports = __webpack_public_path__ + "img/abstract.f77f934c.png";